<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5.basic200.pb-0
        v-row(no-gutters)
          v-col
            h6.mb-0.basic800--text {{ $t('update_2c2p') }}
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              v-icon(color="default" :size="24") mdi-close

      v-card-text.pa-0
        v-form(ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          v-card.pa-4(v-else-if="!isFetching")

            .merchant-id
              p.mb-3.mt-4.label.basic600--text.text-uppercase.mt-2 {{ $t('merchant_id.label') }}
              v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='merchantId' :label="$t('merchant_id.label')" :placeholder="$t('merchant_id.placeholder')" outlined dense persistent-hint hide-details :rules="rules.not_empty")

            .secret-key
              p.mb-3.mt-4.label.basic600--text.text-uppercase.mt-2 {{ $t('secret_key.label') }}
              v-text-field.p1(solo flat background-color="basic200"    height="40" v-model='secretKey' :label="$t('secret_key.label')" :placeholder="$t('secret_key.placeholder')" outlined dense persistent-hint hide-details :rules="rules.not_empty")
            
            //- v-col.mt-4.pa-0.background-inventory(cols="12")
            //-   v-card-actions.pa-0
            //-     v-row(dense)
            //-       v-col.py-0.pr-0
            //-         v-layout
            //-           v-btn.mx-auto(color='primary' text block height="32" small :style="{ 'background-color': (accountEnabled == true)? '#D9EAFE' : '', 'border-radius' : 0 }" @click="accountEnabled = true")
            //-             | {{ $t('enabled') }}
            //-       v-divider.grey(vertical)
            //-       v-col.py-0.pl-0
            //-         v-btn(color='primary', text block height="32" small :style="{ 'background-color': accountEnabled == false? '#D9EAFE' : '', 'border-radius' : 0 }" @click="accountEnabled = false")
            //-           | {{ $t('disabled') }}

      v-divider
      v-card-actions
        v-spacer
        v-btn.button-AA-small(color='primary400', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.button-AA-medium.mr-2.white--text(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
          | {{ $t('update') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Update2c2p',
  props: ['open', 'company'],
  data: () => ({
    fullscreen: true,
    isFetching: true,
    merchantId: null,
    secretKey: null,
    gatewayId: null,
    accountEnabled: true,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fullscreen = window.innerWidth < 600
  },
  created () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchSettings () {
      this.$axios.get(`/twoctwop_creds/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          const gateway = response.data.results[0]
          this.gatewayId = gateway.id
          this.merchantId = gateway.merchant_id
          this.secretKey = gateway.secret_key
          this.accountEnabled = gateway.enabled
        }
        this.isFetching = false
      })
      .catch(() => {})
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('merchant_id', this.merchantId)
      params.set('secret_key', this.secretKey)
      params.set('enabled', this.accountEnabled)
      if (this.gatewayId) {
        this.axios.put(`/twoctwop_creds/${this.gatewayId}/`, params)
        .then(resp => {
          console.log(resp)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/twoctwop_creds/`, params)
        .then(resp => {
          this.$emit('activated', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "update_2c2p": "Update 2c2p",
    "merchant_id": {
      "label": "Merchant ID",
      "placeholder": "Write your merchant id key here"
    },
    "secret_key": {
      "label": "Secret key",
      "placeholder": "Write your secret key here"
    }
  }
}
</i18n>